export enum HeaderEvent {
    Updated = 'ONESERVICE_HEADER_UPDATED',
}
